import { render, staticRenderFns } from "./addComprasOrdenTrabajo.vue?vue&type=template&id=0d8fb79e"
import script from "./addComprasOrdenTrabajo.vue?vue&type=script&lang=js"
export * from "./addComprasOrdenTrabajo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports